import React from 'react'
import { Heading, Animation, PageTitle } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import LessonFooter from '../components/LessonFooter'
import { translate } from '@brainstud/react-tbl/themes/pgw/v1/translations'
import './LessonExercise.css'

const LessonExercise = props => (
  <React.Fragment>
    {!props.lesson.options.hasTitleHidden && props.lesson.options.hasTitleOutside &&
      <Animation name="slideInDown" delay={100}>
        <PageTitle>
          <Heading h1>{props.lesson.title}</Heading>
          <Heading em>{props.lesson.description}</Heading>
        </PageTitle>
      </Animation>
    }

    <div className="Page-content-exercise">
      <div className="Page-content-exercise-label">{translate('app.exercise')}</div>
      {!props.lesson.options.hasTitleHidden && !props.lesson.options.hasTitleOutside &&
        <Animation name="slideInDown" delay={100}>
          <PageTitle>
            <Heading h1>{props.lesson.title}</Heading>
            <Heading em>{props.lesson.description}</Heading>
          </PageTitle>
        </Animation>
      }

      <Animation name="appear" delay={200}>
        {props.children}
      </Animation>
    </div>

    <Animation name="slideInDown" delay={300}>
      <LessonFooter
        chapter={props.chapter}
        lesson={props.lesson}
        handleBack={props.handleBack}
        handleNext={props.handleNext}
        isNextButtonDisabled={props.isNextButtonDisabled} />
    </Animation>
  </React.Fragment>
)

export default LessonExercise
